import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

// Statically import the language-specific components for better SEO.
import TermsOfUseEN from './en/TermsOfUse';
import TermsOfUseHE from './he/TermsOfUse';

const TermsOfUse = () => {
  const lang = useLanguage();

  let LanguageSpecificComponent;

  switch (lang) {
    case 'he':
      LanguageSpecificComponent = TermsOfUseHE;
      break;
    case 'en':
    default:
      LanguageSpecificComponent = TermsOfUseEN;
      break;
  }

  return <LanguageSpecificComponent />;
};

export default TermsOfUse;
